import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useSearchParams, useParams } from "react-router-dom";
import useDebouncedValue from "../Utils/Debounce";
import axiosConfig from "../Service/axiosConfig";
import {
  FaChevronDown,
  FaEllipsisV,
  FaEdit,
  FaExchangeAlt,
  FaTrash,
} from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import CustomSelectProps from "../Components/CustomSelect/Customselect";
import "../Pages/Styles/ViewBatch.css";
import { FormParser, PopupModal } from "../Components";

const StudentView = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(30);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || "";
  const [search, SetSearch] = useState({ search: initialSearch });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const [actionMenuIndex, setActionMenuIndex] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [popupType, setpopupType] = useState("");
  const [transferShow, setTransferShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // for course
  const [selectedBatch, setSelectedBatch] = useState(null); // for batch
  const [courseOptions, setCourseOptions] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const [message, setMessage] = useState("");
  const [Error, setError] = useState("");
  const { batchId } = useParams();
  const [formData, setFormData] = useState({
    course: "",
    batch: "",
    reason: "",
  });

  // Fetch courses on component mount
  useEffect(() => {
    const fetchCourseOptions = async () => {
      setLoading(true);
      try {
        const response = await axiosConfig.get("/accounts/course/");
        const fetchedOptions = response.data?.results?.map((course) => ({
          value: course.id,
          label: course.name,
        }));
        setCourseOptions(fetchedOptions);
      } catch (err) {
        console.error("Error fetching courses", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseOptions();
  }, []);

  // Fetch batches based on selected course
  const getBatches = async (course_id) => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/batch/?course=${course_id || ""}`
      );
      const fetchedOptions = response.data?.results?.map((batch) => ({
        value: batch.id,
        label: batch.name,
      }));
      setBatchOptions(fetchedOptions);
    } catch (err) {
      console.error("Error fetching batches", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch student data
  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/batch-student/?batch=${
          batchId || ""
        }&page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      setData(response?.data?.results);
      setLoading(false);
      setTotalRows(response.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage, debouncedSearchTerm]);

  // Handle selecting a student for transfer
  const handleTransferShow = (student) => {
    setSelectedStudent(student);
    setTransferShow(true);
    setSelectedOption({
      value: student.batch?.course?.id || "",
      label: student.batch?.course?.name || "",
    });
    setSelectedBatch({
      value: student.batch?.id || "",
      label: student.batch?.name || "",
    });
    getBatches(student.batch?.course?.id);
  };
  const handleDelete = (id) => {
    const updatedData = data.filter((student) => student.id !== id);
    setData(updatedData);
  };

  // Close the transfer modal
  const handleClose = () => {
    setTransferShow(false);
  };

  // Handle selection change for course or batch
  const handleSelectChange = (options, name) => {
    console.log(options, name);
    if (name === "course") {
      setSelectedOption(options);
      setSelectedBatch(null);
      getBatches(options?.value);
    } else if (name === "batch") {
      setSelectedBatch(options);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Batch Name",
      selector: (row) => row.batch?.name,
      sortable: true,
    },
    {
      name: "Student Name",
      selector: (row) => row.student?.user?.full_name,
      sortable: true,
    },
    {
      name: "Course Name",
      selector: (row) => row.batch?.course?.name,
    },
    {
      name: "Enrollment Date",
      selector: (row) => row.enrollment_date,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
    },
    {
      name: "Actions",
      cell: (row, index) => (
        <div className="action-cell">
          <button
            className="action-button"
            onClick={(e) => {
              e.stopPropagation();
              setActionMenuIndex(index === actionMenuIndex ? null : index);
            }}
          >
            <FaEllipsisV />
          </button>
          {actionMenuIndex === index && (
            <div className="action-menu">
              <button onClick={() => handleTransferShow(row)}>
                <FaExchangeAlt /> Transfer
              </button>
              <button>
                <FaEdit /> Edit
              </button>
              <button>
                <FaTrash onClick={() => handleDelete(row.id)} /> Delete
              </button>
            </div>
          )}
        </div>
      ),
      width: "100px",
    },
  ];
  const handleTransfer = async () => {
    try {
      if (selectedStudent.id) {
        const response = await axiosConfig.put(
          `/accounts/batch-student/${selectedStudent.id}/`,
          {
            batch_id: selectedBatch.value,
            student_id: selectedStudent?.student?.id,
            course_id: selectedOption.value,
            reason: formData.reason,
          }
        );
        setFormData(response.data);
        setMessage("Batches Transfered successful!");
        setError("");
        setTransferShow(false);
      }
    } catch (error) {
      setMessage("");
      let error_message = error.response?.data?.error;
      console.log(error_message);
      Object.values(error_message) && setError(Object.values(error_message));
      console.error("Error: ", error);
      setpopupType("error");
    }
  };
  console.log(selectedStudent, "datak");
  return (
    <div>
      <div className="custom-effective-table">
        <DataTable
          columns={columns}
          data={data}
          pagination
          fixedHeader
          fixedHeaderScrollHeight="400px"
          selectableRowsHighlight
          sortIcon={<FaChevronDown />}
          draggableColumns
        />
      </div>
      <Modal
        show={transferShow}
        onHide={handleClose}
        size="lg"
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="batch-header">
          <Modal.Title>Transfer Batches</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="transfer-form">
            <div>
              <label>Course Name</label>
              <CustomSelectProps
                placeholder="Course Name"
                value={selectedOption}
                options={courseOptions}
                onChange={(option) => handleSelectChange(option, "course")}
                disabled={true}
              />
            </div>
            <div>
              <label>Batch Name</label>
              <CustomSelectProps
                placeholder="Batch Name"
                value={selectedBatch}
                options={batchOptions}
                onChange={(option) => handleSelectChange(option, "batch")}
              />
            </div>
            <label>Reason</label>
            <br />
            <textarea
              value={formData.reason}
              onChange={(e) =>
                setFormData({ ...formData, reason: e.target.value })
              }
            />
          </div>
          <button className="btn-transfer" onClick={handleTransfer}>
            Transfer
          </button>
        </Modal.Body>
      </Modal>
      {popupType != "" && (
        <PopupModal
          setpopupType={setpopupType}
          popupType={popupType}
          Navigation=""
          error={Error}
          Message={message}
        />
      )}
    </div>
  );
};

export { StudentView };
